import React from "react";
import {Route, Redirect} from "react-router-dom";
import jwt from "jsonwebtoken";

export default function ProtectedRoutes({ component: Component, ...rest }) {
    return (
        <Route
            {...rest}
            render={(props) => {
                const token = localStorage.getItem('token');

                let decoded = jwt.decode(token, {complete: true});
                let now = new Date();
                let tahap = parseInt(localStorage.getItem('tahap'));

                if (token && decoded.payload.exp > (now.getTime()/1000)) {
                    let redirect
                    if ((tahap === 0 || tahap === 1) && rest.tahap !== 0) {
                        redirect = '/user/validasi-pembayaran'
                    } else if (tahap === 2 && rest.tahap !== 2) {
                        redirect = '/user/validasi-biodata'
                    } else if ((tahap === 3 || tahap === 4) && rest.tahap !== 4) {
                        redirect = '/user/validasi-berkas'
                    } else if (tahap === 5 && typeof rest.tahap !== 'undefined') {
                        redirect = '/user/beranda'
                    } else {
                        return <Component {...props} />;
                    }

                    console.log(rest.tahap);

                    return (
                        <Redirect to={{
                            pathname: redirect,
                            state: {
                                from: props.location
                            },
                        }} />
                    )
                } else {
                    return (
                        <Redirect to={{
                            pathname: "/",
                            state: {
                                from: props.location
                            },
                        }} />
                    )
                }
            }}
        />
    )
}